<div style="padding-top: 20px;">
  <p-table #dt [value]="history" id="tb_id" [rows]="10" [paginator]="
    history === undefined
        ? false
        : history.length > 10
    " [rowHover]="false" dataKey="changeTime"  selectionMode="single" [showFirstLastIcon]="false" 
    [sortField]="sortField">
    <ng-template pTemplate="header">
      <tr>
        <th hidden="true" id="head1">id</th>
        <th style="width: 5rem" id="head2"></th>
        <th style="width: 50%" pSortableColumn="changeTime" id="head3"> 
          Dato<p-sortIcon field="changeTime" id="head4"></p-sortIcon>
        </th>
        <th pSortableColumn="changedBy" id="head5">
          Ændret af<p-sortIcon field="changedBy"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-prod let-expanded="expanded">
      <tr [pSelectableRow]="prod">
        <td hidden="true">{{ prod.infRefId }}</td>
        <td>
          <button type="button" pButton [pRowToggler]="prod"  class="p-button-text p-button-plain"
            [icon]="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></button>
        </td>
        <td>{{prod.changeTime}}</td>
        <td>{{ prod.changedBy }}</td>
      </tr>

    </ng-template>
    <ng-template pTemplate="rowexpansion" let-product>
      <tr style="background-color: #ECEFF1; padding-left: 40px;"><td colspan="8">
        <span class="text" style="padding-left: 80px;">Ændret:
          <div *ngFor="let i of product.ruleChange">
            <span style="color: #007BFF">Ruteperiode </span>
            Dato fra:  [{{i.validFrom | date:'yyyy-MM-dd'}}] / Dato til: [{{i.validTo | date:'yyyy-MM-dd'}}]
            <span style="color: #007BFF"></span>
            {{getRecordStatus(i.changeType)}}
            <span style="color: #007BFF"> {{product.changedBy}}, {{product.key.infRef.infRefName}} </span> 
          </div>
          <div>
            <span style="color: #007BFF"> Status   </span>
            <span>
              aendret til  {{ product.isActive ===  true ? 'Aktiv' : 'Inaktiv'}} af </span>
            <span style="color: #007BFF">{{product.changedBy}}</span>
          </div>
        </span>
      </td></tr>
     </ng-template>
  </p-table>
  <br />

</div>
<div>
  <span>
    <button pButton label="Annuller" (click)="backClicked()" class="add-button secondary"></button>
  </span>
</div>